var map = {
	"./18+.svg": "c1c5",
	"./android.svg": "b2fa",
	"./apple.svg": "990a",
	"./banking.svg": "b5dc",
	"./banktransfer.svg": "7e0f",
	"./bitcoin.svg": "a881",
	"./book-of-dead.png": "9491",
	"./curacao.png": "67f5",
	"./curacao.svg": "45b6",
	"./ezeewallet.svg": "fc00",
	"./flexepin.svg": "71df",
	"./gates-of-olympus.png": "188d",
	"./hand.png": "c7dc",
	"./header-bg-mobile.png": "f406",
	"./header-bg.png": "206d",
	"./ic_18Plus.svg": "793b",
	"./ic_ssl.svg": "a2f6",
	"./iterac.svg": "3cc0",
	"./kahnawake.png": "958f",
	"./legasy-of-dead.png": "34b1",
	"./logo-mini.svg": "0df4",
	"./logo.svg": "e347",
	"./mastercard.svg": "2dac",
	"./mifinity.svg": "aa87",
	"./muchbetter.svg": "e075",
	"./neosurf.svg": "3cf1",
	"./neteller.svg": "50f8",
	"./oldman.png": "d516",
	"./one.svg": "fc11",
	"./paysafecard.svg": "444a",
	"./skrill.svg": "19cf",
	"./sofort.svg": "4427",
	"./sweet-bonanza.png": "af1b",
	"./three.svg": "9ce7",
	"./two.svg": "3456",
	"./visa.svg": "f73a",
	"./wolf-gold.png": "5ca0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";